import { render, staticRenderFns } from "./iridium.vue?vue&type=template&id=626ce120&"
import script from "./iridium.vue?vue&type=script&lang=js&"
export * from "./iridium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports